module.exports = __webpack_public_path__ + "resources/img/img_main_bnr_makeit_m.1188737dcd0bdff85c5e6962a8e0da1f.png";